import { IconButton } from '@mui/material';
import { DeleteOutline, PencilOutline, Paperclip, ClipboardTextClockOutline } from 'mdi-material-ui';
import { VigoTooltip } from '../vigo-tooltip';
import { DataGridAction, DataGridColumn, DefaultActions } from './datagrid-types';
import RowActions from './RowActions';
import { Fragment } from 'react';

const evaluateDisabledRow = (row: any, code: string | undefined): boolean => {
  return Boolean(eval(code != undefined ? code : ''));
};

function getWidth(actions: DataGridAction[], defaultActions?: DefaultActions) {
  const inlineCustomCount = actions.filter(a => a.alwaysShow).length;
  const hasOverflowMenu = actions.some(a => !a.alwaysShow);

  const defaultButtons =
    (defaultActions?.canEdit ? 1 : 0) +
    (defaultActions?.canDelete ? 1 : 0) +
    (defaultActions?.showAttachments ? 1 : 0) +
    (defaultActions?.showHistory ? 1 : 0);

  let width = defaultButtons * 40 + inlineCustomCount * 40 + (hasOverflowMenu ? 35 : 0);

  if (width < 80) width = 80;

  return width;
}

export const defaultColumns = (
  actions: DataGridAction[],
  defaultActions?: DefaultActions,
  hideActions?: boolean
): DataGridColumn[] => {
  if (hideActions) {
    return [];
  } else {
    return [
      {
        width: getWidth(actions, defaultActions) + 8,
        minWidth: getWidth(actions, defaultActions) + 8,
        maxWidth: getWidth(actions, defaultActions) + 8,
        sortable: false,
        hideable: false,
        field: 'actions',
        headerName: 'Actions',
        align: 'center',
        headerAlign: 'center',
        disableExport: true,
        renderCell: ({ row }) => (
          <div>
            {defaultActions && defaultActions.canEdit && (
              <>
                <VigoTooltip title={'Edit'}>
                  <IconButton
                    sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                    id={`editBtnUnique`}
                    onClick={() => {
                      if (defaultActions != undefined && defaultActions.editCallBack != undefined) {
                        defaultActions.editCallBack(row.id, row.isDeleted);
                      }
                    }}
                    disabled={defaultActions.editDisabledCallback != null && defaultActions.editDisabledCallback(row)}>
                    <PencilOutline fontSize="medium" />
                  </IconButton>
                </VigoTooltip>
              </>
            )}
            {defaultActions && defaultActions.canDelete && (
              <>
                <VigoTooltip title={'Delete'}>
                  <IconButton
                    sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                    onClick={() => {
                      if (defaultActions != undefined && defaultActions.deleteCallBack != undefined) {
                        defaultActions.deleteCallBack(row.id, row?.version ?? '', row.isDeleted);
                      }
                    }}
                    disabled={
                      defaultActions.deletedDisabledCallback != null && defaultActions.deletedDisabledCallback(row)
                    }>
                    <DeleteOutline fontSize="medium" />
                  </IconButton>
                </VigoTooltip>
              </>
            )}
            {defaultActions && defaultActions.showAttachments && (
              <>
                <VigoTooltip title={'Attactments'}>
                  <IconButton
                    sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                    onClick={() => {
                      //console.log('implement attachements');
                    }}>
                    <Paperclip fontSize="medium" />
                  </IconButton>
                </VigoTooltip>
              </>
            )}
            {defaultActions && defaultActions.showHistory && (
              <>
                <VigoTooltip title={'History'}>
                  <IconButton
                    sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                    onClick={() => {
                      if (defaultActions != undefined && defaultActions.showHistoryCallBack != undefined) {
                        defaultActions.showHistoryCallBack(row.id, row.ownerPartnerId);
                      }
                    }}>
                    <ClipboardTextClockOutline fontSize="medium" />
                  </IconButton>
                </VigoTooltip>
              </>
            )}
            {actions
              .filter(action => action.alwaysShow)
              .map(action => (
                // action.visibleCallback != null &&
                // action.visibleCallback(row) === true && (
                <Fragment key={action.id}>
                  <VigoTooltip title={action.dynamicText !== undefined ? action.dynamicText?.(row) : action.text}>
                    <span>
                      <IconButton
                        id={'actionButton' + action.id}
                        key={action.id}
                        sx={{ ':disabled': 'color: rgba(51, 51, 51, 0.1)', ...(action?.sx ?? {}) }}
                        disabled={action.disableCallback != null && action.disableCallback(row)}
                        onClick={() => {
                          {
                            evaluateDisabledRow(row, 'true');
                            if (action.clickHandler != undefined) {
                              action.clickHandler(row, action.text);
                            }
                          }
                        }}>
                        {action.icon}
                      </IconButton>
                    </span>
                  </VigoTooltip>
                </Fragment>
              ))}
            {actions.length > 0 && <RowActions row={row} actions={actions} />}
          </div>
        )
      }
    ];
  }
};
